
export function accionPermiso(acciones, accion) {
    if (acciones.current.superusuario) return true;
    if (acciones.current.acciones.indexOf(accion) >= 0) return true;
    return false;
}

export function cerrarSesion(data) {
    if (data.mensaje === 'Token no válido.') {
        localStorage.clear();
        window.location.replace('/');
        //window.location.reload(true);
    }
}

export function resetCache() {
    let version = process.env.REACT_APP_VERSION;
    let data = JSON.parse(localStorage.getItem('dat'));
    if (data === null) {
        localStorage.clear();
        window.location.replace('/');
    } else {
        if (version !== data.version) {
            localStorage.clear();
            window.location.replace('/');
        }
    }
}


